import NovalueCheck from './NoValueCheck';

export default (value, age, gender) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;
  var max = 0, min = 0;

  if (age <= 9) {  
    max = 369;
    min = 156;
  } 
  else if (age <= 12) { 
    max = 460;
    min = 141;
  } 
  else if (age <= 14) {
    if (gender == '0') { 
        max = 280;
        min = 62;
    } else {
        max = 517;
        min = 127;
    }
  } 
  else if (age <= 16) {
    if (gender == '0') { 
        max = 128;
        min = 54;
    } else {
        max = 365;
        min = 89;
    }
  } 
  else if (age <= 18) {
    if (gender == '0') { 
        max = 95;
        min = 48;
    } else {
        max = 164;
        min = 59;
    }
  }
  else {
    max = 150;
    min = 40;
  }

  if(value > max) {
    return { 
      title: 'การทำงานของตับผิดปกติ',
      color: 'orange',
      caption: 'ค่า ALP สูงกว่าปกติ',
      suggest: 'ปรับพฤติกรรม พบนักโภชนาการ หรือ นักกำหนดอาหาร'
    };
  } else if(value < min) {
    return { 
      title: 'การทำงานของตับผิดปกติ',
      color: 'orange',
      caption: 'ค่า ALP ต่ำกว่าปกติ',
      suggest: 'ปรับพฤติกรรม พบนักโภชนาการ หรือ นักกำหนดอาหาร'
    };
  } else {
    return { 
      title: 'การทำงานของตับปกติ',
      color: 'green',
      caption: 'การทำงานของตับปกติ',
      suggest: ''
    };
  }

}